import PropTypes from 'prop-types';

export default PropTypes.shape({
  additional: PropTypes.bool,
  text: PropTypes.string,
  value: PropTypes.number,
});
